import axios from 'axios';

const API = axios.create({
	timeout: 360000,
	headers: {
		'Content-Type': 'application/json',
	},
});

API.interceptors.response.use(
	res => res,
	err => {

		if (err.response.status == 500 && (err.response.data.error == 'Token has expired' || err.response.data.error == 'Token not provided')
		) {

			sessionStorage.clear()
			window.location.href = "/auth/login";
		}

		return Promise.reject(err);
	}
)

API.interceptors.request.use(
	config => {

		const token = config.tempToken ? config.tempToken : sessionStorage.getItem('access_token');

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		} else {
			delete API.defaults.headers.common.Authorization;
		}
		return config;
	},

	error => Promise.reject(error)
);

export default API;
